import { getContentDispositionFileName, searchQueryCompiler } from '../../utils/helpers/api-helpers';

interface IFileOptions {
  download?: boolean;
  fileName?: string;
}

interface IFileResponse {
  blobResponse: Blob;
  generalResponse: Response;
}

const defaultConfig: RequestInit = {
  headers: { 'Content-Type': 'application/json' }
};

export enum RequestMethod {
  GET = 'GET',
  POST = 'POST',
  DELETE = 'DELETE',
  PUT = 'PUT',
  PATСH = 'PATCH'
}

async function callFetch<T> (path: string, config?: RequestInit, isBlob?: boolean): Promise<T> {
  const configToSend = { ...defaultConfig, ...config };
  configToSend['headers'] = { ...defaultConfig.headers, ...config?.headers };

  const request = new Request(path, configToSend);
  const response = await fetch(request);
  const contentType = response.headers?.get('content-type');
  if (!response.ok) {
    const errorResult = await response.json();
    const [extractedError] = errorResult;
    throw extractedError;
  }

  if(!contentType || !contentType?.includes('application/json')) {
    // @ts-ignore
    return await response.text();
  }

  return isBlob
    ? {
      blobResponse: await response.blob(),
      generalResponse: response,
    }
    : response.json();
}

const get = async <T>(path: string, params?: { [key: string]: string }, config?: RequestInit, isBlob?: boolean): Promise<T> => {
  const relativeUrl = `${path}${params ? searchQueryCompiler(params) : ''}`;
  const init = { method: RequestMethod.GET, ...config };
  return callFetch<T>(relativeUrl, init, isBlob);
};

const post = async <T, U>(path: string, body: U, config?: RequestInit): Promise<T> => {
  const init = { method: RequestMethod.POST, body: JSON.stringify(body), ...config };
  return callFetch<T>(path, init);
};

const put = async <T, U>(path: string, body: U, config?: RequestInit): Promise<T> => {
  const init = { method: RequestMethod.PUT, body: JSON.stringify(body), ...config };
  return callFetch<T>(path, init);
};

const getFile = async (path: string, options?: IFileOptions, config: RequestInit = {}): Promise<IFileResponse> => {
  const response: IFileResponse = await get(path, {}, config, true);
  const { blobResponse, generalResponse } = response;

  if (options && options.download) {
    const contentDisposition = generalResponse.headers.get('Content-Disposition')!;
    const fileName = options.fileName
      ? options.fileName
      : getContentDispositionFileName(contentDisposition);

    //@ts-ignore
    if (window.navigator.msSaveOrOpenBlob) {
       //@ts-ignore
      window.navigator.msSaveOrOpenBlob(blobResponse, fileName);
    } else {
      const urlCreator = window.URL || window.webkitURL;
      const url = urlCreator.createObjectURL(blobResponse);
      const downloadLink = document.createElement('a');
      downloadLink.style.display = 'none';
      downloadLink.href = url;
      downloadLink.download = fileName;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      window.URL.revokeObjectURL(url);
    }
  }
  return response;
};

export const apiClient = {
  get,
  post,
  put,
  getFile
};

